/**
 * Get cookie options with appropriate domain based on environment/region
 * Shares cookies within the same region/environment
 */
export const getCookieOptions = () => {
    const hostname = window.location.hostname;
    
    // For localhost or IP addresses, don't set domain
    if (hostname === 'localhost' || hostname === '127.0.0.1' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
        return { path: '/' };
    }
    
    // For healthplan.com hosts, handle region+carrier vs prod carrier-only
    if (hostname.endsWith('healthplan.com')) {
        const subdomainParts = hostname.split('.')[0].split('-');
        const regionPrefixes = ['dev', 'sit', 'qua', 'uat', 'pfix'];
        const region = subdomainParts[0]?.toLowerCase();

        // Env-only host: dev-member.healthplan.com -> .dev-member.healthplan.com
        if (regionPrefixes.includes(region) && subdomainParts.length === 2) {
            return { domain: `.${subdomainParts.slice(0,2).join('-')}.healthplan.com`, path: '/' };
        }

        // Regioned env: dev-cigna-member.healthplan.com -> .dev-cigna-member.healthplan.com (no leakage to other carriers or regions)
        if (regionPrefixes.includes(region) && subdomainParts.length >= 3) {
            return { domain: `.${subdomainParts.slice(0,3).join('-')}.healthplan.com`, path: '/' };
        }

        // Prod (no region prefix): cigna-member.healthplan.com -> .cigna-member.healthplan.com (carrier-scoped only)
        if (subdomainParts.length >= 2) {
            return { domain: `.${subdomainParts.slice(0,2).join('-')}.healthplan.com`, path: '/' };
        }
    }

    // Fallback: restrict to current host
    return { domain: hostname, path: '/' };
};
